module.exports = __webpack_public_path__ + "media/images/webpage/hotels/3105/meal-0ed0a7eced6c9122888a2c560fd2ed1a.webp";